import { useEffect } from "react";
import { startFinanceFetch } from "../redux/actions/EquipmentFinanceActions";
import type { EquipmentV2DispatchType } from "../redux/store";
import { useDispatch } from "../../../../shared-logic/redux/store";

const useInitEquipmentV2 = (): void => {
    const dispatch = useDispatch<EquipmentV2DispatchType>();

    useEffect(() => {
        dispatch(startFinanceFetch());
    }, []);
};

export default useInitEquipmentV2;
